// ============================================================
// STATE
// ============================================================
const state = {
    size: 'large',
    color: '#C0C0C0',
    font: 'Arial Black',
    text: 'YOUR NAME',
    bgColor: '#1a5983',
    leftFigure: null,   // { id, name, filename }
    rightFigure: null,
    leftMirror: false,
    rightMirror: false
};

const SIZE_LABELS = { small: 'Small Holder (30cm)', large: 'Large Holder (50cm)' };

// ============================================================
// INIT
// ============================================================
document.addEventListener('DOMContentLoaded', function () {
    initializeColors();
    loadFigureOptions();
    attachFigureEventListeners();
    updatePriceDisplay();

    const btnOrder = document.getElementById('btn-order');
    if (btnOrder) btnOrder.addEventListener('click', addToCart);

    window.addEventListener('resize', function () {
        const nameInput = document.getElementById('name-input');
        const textEl = document.getElementById('custom-text');
        if (textEl && nameInput) {
            const text = nameInput.value || 'YOUR NAME';
            textEl.style.fontSize = getPreciseFontSize(text.length || 1, window.innerWidth) + 'px';
        }
    });
});

// ============================================================
// COLORS / FONT / BACKGROUND
// ============================================================
function initializeColors() {
    updateColors('#C0C0C0');
    updateBackgroundColor('#1a5983');
    updateFont('Arial Black');
    updateFigure('left', 'none');
    updateFigure('right', 'none');
    initializeMirrorButtons();

    const textEl = document.getElementById('custom-text');
    if (textEl) {
        textEl.style.fontSize = getPreciseFontSize(9, window.innerWidth) + 'px';
    }
}

document.getElementById('name-input').addEventListener('input', function (e) {
    const text = e.target.value || 'YOUR NAME';
    state.text = text;
    const textEl = document.getElementById('custom-text');
    textEl.textContent = text.toUpperCase();
    textEl.style.fontSize = getPreciseFontSize(text.length || 1, window.innerWidth) + 'px';
    textEl.style.lineHeight = '1';
    textEl.style.alignItems = 'flex-end';
});

document.querySelectorAll('.color-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
        document.querySelectorAll('.color-option').forEach(function (o) { o.classList.remove('active'); });
        this.classList.add('active');
        const color = this.getAttribute('data-color');
        state.color = color;
        updateColors(color);
    });
});

document.querySelectorAll('.font-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
        document.querySelectorAll('.font-option').forEach(function (o) { o.classList.remove('active'); });
        this.classList.add('active');
        const font = this.getAttribute('data-font');
        state.font = font;
        updateFont(font);
    });
});

document.querySelectorAll('.bg-color-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
        document.querySelectorAll('.bg-color-option').forEach(function (o) { o.classList.remove('active'); });
        this.classList.add('active');
        const color = this.getAttribute('data-color');
        state.bgColor = color;
        document.getElementById('bg-color-picker').value = color;
        updateBackgroundColor(color);
    });
});

document.getElementById('bg-color-picker').addEventListener('input', function (e) {
    document.querySelectorAll('.bg-color-option').forEach(function (o) { o.classList.remove('active'); });
    state.bgColor = e.target.value;
    updateBackgroundColor(e.target.value);
});

function updateColors(color) {
    const controls = document.querySelector('.controls');
    if (controls) controls.style.setProperty('--selected-color', color);
    const floodEl = document.getElementById('flood-color');
    if (floodEl) floodEl.setAttribute('flood-color', color);
    updateTextColor(color);
}

function updateTextColor(color) {
    const textEl = document.getElementById('custom-text');
    if (textEl) textEl.style.color = color;
}

function updateFont(fontFamily) {
    const textEl = document.getElementById('custom-text');
    if (!textEl) return;
    const map = {
        'Arial Black': "'Arial Black', Arial, sans-serif",
        'Pattaya': "'Pattaya', cursive",
        'Lubalin': "'Lubalin', serif"
    };
    textEl.style.fontFamily = map[fontFamily] || "'Arial Black', Arial, sans-serif";
}

function updateBackgroundColor(color) {
    const pc = document.querySelector('.preview-container');
    if (pc) {
        pc.style.backgroundImage = 'none';
        pc.style.backgroundColor = color;
        pc.classList.toggle('light-bg', color !== '#1a5983');
    }
}

// ============================================================
// FONT SIZE
// ============================================================
function getPreciseFontSize(charCount, screenWidth) {
    const map = {
        desktop:        { 1:60,2:60,3:60,4:60,5:60,6:60,7:50,8:45,9:40,10:35,11:34 },
        tablet:         { 1:45,2:45,3:45,4:45,5:45,6:45,7:40,8:38,9:36,10:33,11:30 },
        mobile:         { 1:30,2:30,3:30,4:30,5:30,6:30,7:24,8:21,9:19,10:16,11:16 },
        mediumMobile:   { 1:30,2:30,3:30,4:30,5:30,6:30,7:30,8:30,9:28,10:27,11:26 },
        smallMobile:    { 1:30,2:30,3:30,4:30,5:30,6:30,7:28,8:25,9:22,10:20,11:18 },
        extraSmallMobile:{ 1:30,2:30,3:30,4:30,5:30,6:30,7:24,8:21,9:19,10:16,11:16 }
    };
    let device;
    if (screenWidth >= 1200) device = 'desktop';
    else if (screenWidth >= 768) device = 'tablet';
    else if (screenWidth >= 601) device = 'mobile';
    else if (screenWidth >= 481) device = 'mediumMobile';
    else if (screenWidth >= 401) device = 'smallMobile';
    else device = 'extraSmallMobile';
    return map[device][charCount] || map[device][11];
}

// ============================================================
// SIZE SELECTOR
// ============================================================
document.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
        document.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
        const size = this.getAttribute('data-size');
        state.size = size;
        const hangerEl = document.querySelector('.hanger-element');
        const previewContainer = document.querySelector('.preview-container');
        const medalsEl = document.getElementById('medals-overlay');
        if (hangerEl) hangerEl.src = window.HANGER_IMAGE_URLS[size];
        if (previewContainer) previewContainer.classList.toggle('small-holder', size === 'small');
        if (medalsEl) {
            medalsEl.classList.remove('medals-overlay-za-mali-drzac', 'medals-overlay-za-veliki-drzac');
            medalsEl.classList.add(size === 'small' ? 'medals-overlay-za-mali-drzac' : 'medals-overlay-za-veliki-drzac');
        }
        updatePriceDisplay();
    });
});

function updatePriceDisplay() {
    const variant = window.MEDAL_HANGER_VARIANTS[state.size];
    const priceEl = document.getElementById('price-display');
    const summaryPrice = document.getElementById('summary-price');
    const summarySize = document.getElementById('summary-size');
    if (priceEl) priceEl.textContent = variant.priceFormatted;
    if (summaryPrice) summaryPrice.textContent = variant.priceFormatted;
    if (summarySize) summarySize.textContent = SIZE_LABELS[state.size];
}

// ============================================================
// FIGURES
// ============================================================
function figureImageUrl(filename) {
    return window.ASSET_BASE_URL + filename;
}

function updateFigure(side, figureKey) {
    const figureEl = document.getElementById(side + '-figure');
    if (!figureEl) return;

    if (figureKey === 'none') {
        figureEl.innerHTML = '';
        if (side === 'left') state.leftFigure = null;
        else state.rightFigure = null;
        return;
    }

    const figureOption = window.figureOptions.find(function (opt) { return opt.id === figureKey; });
    if (!figureOption) return;

    const src = figureImageUrl(figureOption.filename);
    figureEl.innerHTML = '<img src="' + src + '" alt="' + figureOption.name + '" class="figure-img" style="width:100%;height:100%;object-fit:contain;" data-original-src="' + src + '">';

    if (side === 'left') state.leftFigure = { id: figureOption.id, name: figureOption.name, filename: figureOption.filename };
    else state.rightFigure = { id: figureOption.id, name: figureOption.name, filename: figureOption.filename };
}

function loadFigureOptions() {
    const figureOptions = window.figureOptions || [];
    updateScrollMenus(figureOptions);
}

function updateScrollMenus(figureOptions) {
    const leftMenu = document.getElementById('left-figure-menu');
    const rightMenu = document.getElementById('right-figure-menu');
    if (!leftMenu || !rightMenu) return;

    document.querySelectorAll('.figure-option:not([data-figure="none"])').forEach(function (o) { o.remove(); });

    figureOptions.forEach(function (figure) {
        leftMenu.appendChild(createFigureOption(figure));
        rightMenu.appendChild(createFigureOption(figure));
    });

    if (figureOptions.length >= 1) {
        const first = leftMenu.querySelector('[data-figure="' + figureOptions[0].id + '"]');
        if (first) { first.classList.add('active'); updateFigure('left', figureOptions[0].id); }
    }
    if (figureOptions.length >= 2) {
        const second = rightMenu.querySelector('[data-figure="' + figureOptions[1].id + '"]');
        if (second) { second.classList.add('active'); updateFigure('right', figureOptions[1].id); }
    }

    attachFigureEventListeners();
}

function createFigureOption(figure) {
    const div = document.createElement('div');
    div.className = 'figure-option';
    div.setAttribute('data-figure', figure.id);
    div.setAttribute('title', figure.name);
    div.innerHTML = '<img src="' + figureImageUrl(figure.filename) + '" alt="' + figure.name + '" style="width:48px;height:48px;object-fit:contain;">';
    return div;
}

function attachFigureEventListeners() {
    document.querySelectorAll('#left-figure-menu .figure-option').forEach(function (opt) {
        opt.removeEventListener('click', leftClickHandler);
        opt.addEventListener('click', leftClickHandler);
    });
    document.querySelectorAll('#right-figure-menu .figure-option').forEach(function (opt) {
        opt.removeEventListener('click', rightClickHandler);
        opt.addEventListener('click', rightClickHandler);
    });
}

function leftClickHandler() {
    document.querySelectorAll('#left-figure-menu .figure-option').forEach(function (o) { o.classList.remove('active'); });
    this.classList.add('active');
    updateFigure('left', this.getAttribute('data-figure'));
}

function rightClickHandler() {
    document.querySelectorAll('#right-figure-menu .figure-option').forEach(function (o) { o.classList.remove('active'); });
    this.classList.add('active');
    updateFigure('right', this.getAttribute('data-figure'));
}

// ============================================================
// MIRROR
// ============================================================
function initializeMirrorButtons() {
    const leftBtn = document.getElementById('left-mirror-btn');
    const rightBtn = document.getElementById('right-mirror-btn');
    if (leftBtn) leftBtn.addEventListener('click', function () { toggleMirror('left'); });
    if (rightBtn) rightBtn.addEventListener('click', function () { toggleMirror('right'); });
}

function toggleMirror(side) {
    const figureEl = document.querySelector(side === 'left' ? '.left-image' : '.right-image');
    const mirrorBtn = document.getElementById(side + '-mirror-btn');
    if (!figureEl || !mirrorBtn) return;

    const isMirrored = figureEl.style.transform && figureEl.style.transform.includes('scaleX(-1)');
    if (isMirrored) {
        figureEl.style.transform = figureEl.style.transform.replace('scaleX(-1)', '').trim();
        mirrorBtn.classList.remove('active');
        mirrorBtn.textContent = 'Mirror';
        if (side === 'left') state.leftMirror = false;
        else state.rightMirror = false;
    } else {
        figureEl.style.transform = (figureEl.style.transform || '') + ' scaleX(-1)';
        mirrorBtn.classList.add('active');
        mirrorBtn.textContent = 'Mirrored';
        if (side === 'left') state.leftMirror = true;
        else state.rightMirror = true;
    }
}

// ============================================================
// ADD TO CART (Shopify)
// ============================================================
async function addToCart() {
    const btn = document.getElementById('btn-order');
    const errorDiv = document.getElementById('form-error');
    const originalLabel = btn ? btn.innerHTML : '';

    if (errorDiv) errorDiv.style.display = 'none';
    if (btn) {
        btn.disabled = true;
        btn.textContent = '⏳ Adding to cart...';
    }

    try {
        const variant = window.MEDAL_HANGER_VARIANTS[state.size];
        if (!variant || !variant.id) {
            throw new Error('This size is not available right now.');
        }

        // Generate preview image (used only for the order notification emails)
        const canvas = await createCanvasComposition();
        const previewBase64 = canvas.toDataURL('image/png');

        let previewImageUrl = '';
        if (window.PREVIEW_UPLOAD_URL) {
            try {
                const uploadResponse = await fetch(window.PREVIEW_UPLOAD_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ preview_image: previewBase64 })
                });
                const uploadResult = await uploadResponse.json();
                if (uploadResult && uploadResult.url) previewImageUrl = uploadResult.url;
            } catch (uploadErr) {
                console.warn('Preview image upload failed, continuing without it:', uploadErr);
            }
        }

        const customText = document.getElementById('name-input').value.trim() || 'YOUR NAME';
        const leftFigureLabel = state.leftFigure ? (state.leftFigure.name + (state.leftMirror ? ' (mirrored)' : '')) : 'None';
        const rightFigureLabel = state.rightFigure ? (state.rightFigure.name + (state.rightMirror ? ' (mirrored)' : '')) : 'None';

        const properties = {
            'Size': SIZE_LABELS[state.size],
            'Custom Text': customText,
            'Hanger Color': state.color,
            'Background Color': state.bgColor,
            'Font': state.font,
            'Left Figure': leftFigureLabel,
            'Right Figure': rightFigureLabel
        };
        // Leading underscore hides this property from the cart/checkout UI,
        // it is only used inside the order notification email templates.
        if (previewImageUrl) properties['_Preview Image'] = previewImageUrl;

        const cartResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{ id: variant.id, quantity: 1, properties: properties }]
            })
        });

        if (!cartResponse.ok) {
            const errData = await cartResponse.json().catch(function () { return {}; });
            throw new Error(errData.description || 'Could not add the product to your cart.');
        }

        window.location.href = '/cart';

    } catch (err) {
        console.error('Add to cart error:', err);
        if (errorDiv) {
            errorDiv.textContent = 'Something went wrong: ' + err.message + ' Please try again or contact us.';
            errorDiv.style.display = 'block';
            errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (btn) {
            btn.disabled = false;
            btn.innerHTML = originalLabel;
        }
    }
}

// ============================================================
// CANVAS COMPOSITION (for preview image)
// ============================================================
async function createCanvasComposition() {
    const previewContainer = document.querySelector('.preview-container');
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const rect = previewContainer.getBoundingClientRect();

    canvas.width = rect.width * 3;
    canvas.height = rect.height * 3;
    ctx.scale(3, 3);

    // Background
    const computedBg = window.getComputedStyle(previewContainer).backgroundColor;
    ctx.fillStyle = computedBg || '#1a5983';
    ctx.fillRect(0, 0, rect.width, rect.height);

    const activeColor = document.querySelector('.color-option.active')?.getAttribute('data-color') || '#C0C0C0';

    // Background image (if set)
    const bgImage = window.getComputedStyle(previewContainer).backgroundImage;
    if (bgImage && bgImage !== 'none') {
        const imageUrl = bgImage.slice(4, -1).replace(/"/g, '');
        try {
            const img = await loadImage(imageUrl);
            ctx.drawImage(img, 0, 0, rect.width, rect.height);
        } catch (e) { /* skip */ }
    }

    // Left figure
    await drawFigure(ctx, '.left-image', previewContainer, activeColor);
    // Right figure
    await drawFigure(ctx, '.right-image', previewContainer, activeColor);

    // Hanger
    const hangerEl = document.querySelector('.hanger-element');
    if (hangerEl && hangerEl.src) {
        try {
            const hangerImg = await loadImage(hangerEl.src);
            const hr = hangerEl.getBoundingClientRect();
            const cr = previewContainer.getBoundingClientRect();
            const x = hr.left - cr.left;
            const y = hr.top - cr.top;

            const off = document.createElement('canvas');
            off.width = hr.width;
            off.height = hr.height;
            const octx = off.getContext('2d');
            octx.drawImage(hangerImg, 0, 0, hr.width, hr.height);
            if (activeColor !== '#C0C0C0') {
                octx.globalCompositeOperation = 'source-in';
                octx.fillStyle = activeColor;
                octx.fillRect(0, 0, hr.width, hr.height);
            }
            ctx.drawImage(off, x, y);
        } catch (e) { /* skip */ }
    }

    // Medals overlay
    const medalsEl = document.getElementById('medals-overlay');
    if (medalsEl && medalsEl.src) {
        try {
            const medalsImg = await loadImage(medalsEl.src);
            const mr = medalsEl.getBoundingClientRect();
            const cr = previewContainer.getBoundingClientRect();
            ctx.drawImage(medalsImg, mr.left - cr.left, mr.top - cr.top, mr.width, mr.height);
        } catch (e) { /* skip */ }
    }

    // Text
    const textEl = document.getElementById('custom-text');
    if (textEl) {
        const tr = textEl.getBoundingClientRect();
        const cr = previewContainer.getBoundingClientRect();
        const cs = window.getComputedStyle(textEl);
        ctx.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
        ctx.fillStyle = activeColor;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        ctx.shadowColor = 'rgba(0,0,0,0.8)';
        ctx.shadowBlur = 10;
        ctx.shadowOffsetX = 3;
        ctx.shadowOffsetY = 3;
        // Text uses flex align-items:flex-end — draw at the bottom of the bounding box, not centered
        ctx.fillText(textEl.textContent, (tr.left - cr.left) + tr.width / 2, (tr.top - cr.top) + tr.height);
    }

    return canvas;
}

async function drawFigure(ctx, selector, previewContainer, activeColor) {
    const figureEl = document.querySelector(selector);
    if (!figureEl) return;
    const img = figureEl.querySelector('.figure-img');
    if (!img || !img.src) return;

    try {
        const figureImg = await loadImage(img.src);
        const fr = figureEl.getBoundingClientRect();
        const cr = previewContainer.getBoundingClientRect();
        const x = fr.left - cr.left;
        const y = fr.top - cr.top;

        // Offscreen canvas — colorize in isolation, never touch main canvas composite state
        const off = document.createElement('canvas');
        off.width = fr.width;
        off.height = fr.height;
        const octx = off.getContext('2d');

        const transform = figureEl.style.transform || '';
        if (transform.includes('scaleX(-1)')) {
            octx.translate(fr.width, 0);
            octx.scale(-1, 1);
        }
        octx.drawImage(figureImg, 0, 0, fr.width, fr.height);

        if (activeColor !== '#C0C0C0') {
            octx.globalCompositeOperation = 'source-in';
            octx.fillStyle = activeColor;
            octx.fillRect(0, 0, fr.width, fr.height);
        }

        ctx.drawImage(off, x, y);
    } catch (e) { /* skip */ }
}

function loadImage(src) {
    return new Promise(function (resolve, reject) {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { resolve(img); };
        img.onerror = reject;
        img.src = src;
    });
}
